import React, { useState, useEffect, memo } from 'react';
import { MessageCircle } from 'lucide-react';

// WhatsApp configuration
const WHATSAPP_NUMBER = '917619546174';
const WHATSAPP_MESSAGE = 'Hello! I would like to inquire about your saree collection.';
const WHATSAPP_URL = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(WHATSAPP_MESSAGE)}`;

const FloatingWhatsApp = memo(() => {
  const [isVisible, setIsVisible] = useState(false);
  const [isPulsing, setIsPulsing] = useState(true);

  useEffect(() => {
    // Show button after modal is dismissed (slight delay)
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, 1000);

    // Stop pulsing after 10 seconds
    const pulseTimer = setTimeout(() => {
      setIsPulsing(false);
    }, 10000);

    return () => {
      clearTimeout(timer);
      clearTimeout(pulseTimer);
    };
  }, []);

  if (!isVisible) return null;

  return (
    <a
      href={WHATSAPP_URL}
      target="_blank"
      rel="noopener noreferrer"
      className="fixed right-6 top-1/2 -translate-y-1/2 z-40 group"
      aria-label="Chat on WhatsApp"
    >
      {/* Pulse ring animation */}
      {isPulsing && (
        <>
          <div 
            className="absolute inset-0 rounded-full bg-primary/30 animate-ping"
            style={{ animationDuration: '2s' }}
          />
          <div 
            className="absolute inset-0 rounded-full bg-primary/20 animate-ping"
            style={{ animationDuration: '2s', animationDelay: '0.5s' }}
          />
        </>
      )}
      
      {/* Main button */}
      <div 
        className="relative w-14 h-14 rounded-full flex items-center justify-center transition-all duration-300 group-hover:scale-110 group-hover:opacity-100 opacity-50"
        style={{
          background: 'linear-gradient(135deg, hsl(43 74% 49%) 0%, hsl(45 93% 55%) 50%, hsl(43 74% 49%) 100%)',
          boxShadow: '0 4px 20px rgba(212, 166, 52, 0.4), 0 0 30px rgba(212, 166, 52, 0.2)',
        }}
      >
        <MessageCircle 
          className="w-7 h-7 transition-transform duration-300 group-hover:scale-110" 
          style={{ color: '#0A0A0A' }}
          strokeWidth={2.5}
        />
      </div>
      
      {/* Tooltip on hover */}
      <div className="absolute right-full mr-3 top-1/2 -translate-y-1/2 opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none">
        <div className="glass px-4 py-2 rounded-lg whitespace-nowrap">
          <p className="font-body text-sm text-foreground">Chat with us!</p>
        </div>
      </div>
    </a>
  );
});

FloatingWhatsApp.displayName = 'FloatingWhatsApp';

export default FloatingWhatsApp;
